export default __webpack_public_path__ + "static/media/tiktok.330cd6e2.svg";